<template>
  <form-panel
    width="large"
    title="Nueva maquinaria"
    @closePanel="onCloseModal">
    <machineries-form
      :old="oldMachinerie"
      :customer="customer"/>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import MachineriesForm from '@/modules/machineries/machineries-form'
export default {
  name: 'MachineriesCreateView',
  components: {
    FormPanel,
    MachineriesForm
  },
  props: {
    old: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oldMachinerie: null
    }
  },
  provide () {
    return {
      tractors: this.tractors,
      brands: this.brands,
      types: this.types
    }
  },
  computed: {
    tractors () {
      return this.$store.getters['tractors/items']
    },
    types () {
      return this.$store.getters['machineryTypes/items']
    },
    brands () {
      return this.$store.getters['brands/items']
    },
    customer () {
      return this.$store.getters['customers/item']
    }
  },
  mounted () {
    if (this.isEdit) {
      this.oldMachinerie = this.old
    } else {
      this.oldMachinerie = null
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('closeEdicionMachinerie', false)
      this.$store.dispatch('app/toggleTractorPanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/machineries/machineries-create-view.vue